import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AdminsList from "./AdminsList";

const Index = ({ match }) => {
  return (
    < div >
      <Switch>
        <Route path={`${match.url}/`} component={AdminsList} />
        <Redirect to="/error" />
      </Switch>
    </div >
  )

};
export default Index;
